export default __webpack_public_path__ + "static/media/roz3-big.8bc0e398.png";